// @ts-nocheck
/**
 * BRINUTI — TERMÉKLISTA: „További naplók" + állapotmegőrzés
 *
 * A CRO-elemzés két dolgot kér a kollekciótól (25. pont és a 11. fejezet
 * replayje): lapozó helyett utántöltést, és azt, hogy visszatéréskor a
 * látogató ott folytassa, ahol abbahagyta. A 33 oldalas „kollekció-őrlő"
 * pontosan azon bukott el, hogy minden visszalépés után elölről kellett
 * felépítenie a keresési állapotot.
 *
 * Hogyan:
 *   - a számozott lapozót elrejtjük (JS nélkül marad, tehát megvan a
 *     tartalék út is), helyette egy gomb tölti be a következő oldalt a
 *     Shopify szekció-renderelő API-járól;
 *   - kattintáskor eltesszük, hány oldal van betöltve és hol állt a görgetés,
 *     visszatéréskor pedig ugyanoda állunk vissza.
 *
 * A CÍM NEM VÁLTOZIK utántöltéskor. Szándékosan: a /collections/all a
 * hirdetések céloldala, és egy ?page=3-ra átírt cím frissítéskor pont az
 * addig betöltött listát dobná el.
 */
(function () {
  'use strict';

  const TAROLO_ELOTAG = 'brinuti-lista:';
  const ERVENYES_MP = 30 * 60 * 1000; // fél óra

  const lista = document.querySelector('results-list[section-id]');
  if (!lista) return;

  // A rács hivatkozását nem tesszük el: a téma saját results-list komponense
  // szűréskor újrarajzolja a listát, és egy leszakadt elembe pakolnánk a
  // kártyákat. Mindig frissen kérdezzük le.
  function racsElem() {
    return lista.querySelector('ul.product-grid');
  }

  const racs = racsElem();
  if (!racs) return;

  const szekcioId = lista.getAttribute('section-id');
  const utolsoOldal = Number(racs.dataset.lastPage || '1');
  const osszesTermek = Number(racs.dataset.brinutiOsszes || '0');

  // Az oldalszám a címből jön; enélkül az első oldalon vagyunk.
  const kezdoOldal = Number(new URL(window.location.href).searchParams.get('page') || '1');
  let betoltottOldal = kezdoOldal;
  let toltesFolyamatban = false;

  /* KÉT BETÖLTŐ, EGY LISTA (javítás 2026-09-19, a tulaj jelezte, hogy a 97.
     borító után „elölről kezdi").

     A lapon két utántöltő dolgozik: a téma saját végtelen görgetése
     (paginated-list.js, görgetésre tölt) és ez a gomb. A kettő eddig nem
     tudott egymásról: a görgetés betöltötte mind az öt oldalt, a gomb
     viszont a SAJÁT számlálója szerint még az 1. oldalon állt — „Továbbiak
     betöltése (73)" felirattal ott maradt 97 kártya alatt, és kattintásra a
     2. oldaltól újra behúzta a borítókat. Ráadásul a téma a címbe írta a
     lapszámot (?page=5), így visszalépéskor vagy frissítéskor a lista az 5.
     oldallal — egyetlen borítóval — indult.

     Ezért mostantól:
       - hogy hol tartunk, azt a rácsban TÉNYLEG ott lévő kártyákból
         olvassuk (data-page), nem egy saját változóból;
       - egy termék kétszer nem kerülhet a rácsba (a link alapján szűrünk);
       - a gomb eltűnik, amint mind a 97 (az összes) kint van;
       - a lapszám nem kerül a címbe: a téma pushState-jéből kivesszük. */
  function termekLink(elem) {
    const a = elem.querySelector && elem.querySelector('a[href*="/products/"]');
    /* A sablonban a href elé sortörés kerülhet — trim nélkül ugyanaz a
       termék két különböző kulcsot adna. */
    return a ? a.getAttribute('href').trim().split('?')[0] : null;
  }

  function latszoKartyak() {
    const r = racsElem();
    return r ? Array.from(r.querySelectorAll('.product-grid__item')) : [];
  }

  function latszoOldal() {
    let legnagyobb = betoltottOldal;
    latszoKartyak().forEach(function (k) {
      const o = Number(k.dataset.page || 0);
      if (o > legnagyobb) legnagyobb = o;
    });
    return legnagyobb;
  }

  function minden() {
    return latszoOldal() >= utolsoOldal ||
      (osszesTermek > 0 && latszoKartyak().length >= osszesTermek);
  }

  const eredetiPushState = history.pushState;
  history.pushState = function (allapot, cim, url) {
    if (url) {
      try {
        const uj = new URL(String(url), window.location.href);
        if (uj.pathname === window.location.pathname && uj.searchParams.has('page')) {
          uj.searchParams.delete('page');
          return history.replaceState(allapot, cim, uj.toString());
        }
      } catch (e) { /* ismeretlen cím — hagyjuk a téma szerint */ }
    }
    return eredetiPushState.apply(this, arguments);
  };

  /**
   * A tárolókulcs a SZŰRT LISTÁT azonosítja, nem a pillanatnyi oldalszámot.
   * A `page` és a `section_id` ezért kimarad belőle: visszatéréskor a böngésző
   * gyakran `?page=1`-gyel adja vissza ugyanazt a listát, és kulcs-eltérés
   * miatt nem találnánk meg a mentett állapotot. (Lemérve: kimentve
   * „/collections/all", visszajövet „/collections/all?page=1".)
   */
  function kulcsKeszites() {
    const cim = new URL(window.location.href);
    cim.searchParams.delete('page');
    cim.searchParams.delete('section_id');
    cim.searchParams.sort();
    return TAROLO_ELOTAG + cim.pathname + cim.search;
  }

  const kulcs = kulcsKeszites();

  /* ------------------------------------------------------------------ */
  /* Ismétlődő kártyák kiszűrése                                         */
  /* ------------------------------------------------------------------ */

  /* JAVÍTÁS (2026-09-21, tesztelés közben lemérve): a Naplók listáján 97
     borító van, de végiggörgetve 193 kártya jött ki — a 2. oldal ÖTSZÖR
     került be. A téma saját végtelen görgetője (paginated-list.js) minden
     görgetésre elindít egy betöltést, és nem néz rá, hogy fut-e már egy:
     amíg a 2. oldal hálózatról érkezik, addig a görgetés még négyszer
     „kéri” ugyanazt, és mind az öt válasz beleömlik a rácsba. Lassú neten
     ez biztosan előjön, gyorsan pedig akkor, ha a vásárló gyorsan görget.

     A saját gombunk már figyel az ismétlődésre (lásd fönt, `toltsBe`), de a
     téma görgetője nem tud róla. Ezért a RÁCSOT magát őrizzük: bármi is
     teszi be a kártyát, egy termék csak egyszer maradhat benn. A linkből
     dolgozunk (az azonosítja a terméket), és mindig az ELSŐ példányt
     hagyjuk meg, így a sorrend nem borul fel.

     A rács utolsó kártyájának `data-page` értéke ettől nem csökken (az első
     példányt megtartjuk), tehát a téma innen is helyesen olvassa ki, hogy
     melyik a következő oldal — nem ragad be körbe-körbe. */
  function ismetlodokTorlese() {
    const r = racsElem();
    if (!r) return;
    const latott = new Set();
    Array.prototype.forEach.call(r.querySelectorAll('.product-grid__item'), function (kartya) {
      const link = termekLink(kartya);
      /* A rácsban nem csak termék lehet (pl. vásárlói kártya) — azt nem
         bántjuk, mert nincs termékhivatkozása. */
      if (!link) return;
      if (latott.has(link)) {
        kartya.remove();
        return;
      }
      latott.add(link);
    });
  }

  ismetlodokTorlese();

  let szuresKert = false;
  new MutationObserver(function () {
    if (szuresKert) return;
    szuresKert = true;
    requestAnimationFrame(function () {
      szuresKert = false;
      ismetlodokTorlese();
    });
  }).observe(lista, { childList: true, subtree: true });


  /* ------------------------------------------------------------------ */
  /* Utántöltés                                                          */
  /* ------------------------------------------------------------------ */

  /**
   * Egy oldal termékkártyáinak beolvasása a szekció-renderelő API-ról.
   * @param {number} oldal
   * @returns {Promise<Element[]>} a kártyák <li> elemei
   */
  async function oldalLekerese(oldal) {
    const cim = new URL(window.location.href);
    cim.searchParams.set('page', String(oldal));
    cim.searchParams.set('section_id', szekcioId);
    cim.hash = '';

    const valasz = await fetch(cim.toString());
    if (!valasz.ok) throw new Error('A lista betöltése nem sikerült: ' + valasz.status);

    const szoveg = await valasz.text();
    const doboz = document.createElement('div');
    doboz.innerHTML = szoveg;

    const ujRacs = doboz.querySelector('ul.product-grid');
    return ujRacs ? Array.from(ujRacs.children) : [];
  }

  /**
   * @param {number} oldal
   * @returns {Promise<number>} hány kártya került be
   */
  async function toltsBe(oldal) {
    const elemek = await oldalLekerese(oldal);
    const cel = racsElem();
    if (!cel) return 0;
    const megvan = new Set(latszoKartyak().map(termekLink).filter(Boolean));
    let db = 0;
    elemek.forEach(function (elem) {
      const link = termekLink(elem);
      if (link && megvan.has(link)) return;
      if (link) megvan.add(link);
      cel.appendChild(elem);
      db += 1;
    });
    betoltottOldal = Math.max(betoltottOldal, oldal);
    return db;
  }

  /* ------------------------------------------------------------------ */
  /* Gomb                                                                */
  /* ------------------------------------------------------------------ */

  const gomb = document.createElement('button');
  gomb.type = 'button';
  gomb.className = 'brinuti-tovabbi-gomb';

  // Számláló a gomb alatt: „{látszik} / {összes}". A doksi C8 pontja kéri —
  // a lapszám helyett a látogató azt akarja tudni, hol tart a 100-ban.
  const szamlalo = document.createElement('p');
  szamlalo.className = 'brinuti-tovabbi-szamlalo';

  const gombSor = document.createElement('div');
  gombSor.className = 'brinuti-tovabbi';
  gombSor.appendChild(gomb);
  gombSor.appendChild(szamlalo);

  // Csak akkor írunk bele, ha változik: a rácsot figyelő MutationObserver
  // különben a saját írásunkra is lefutna, és körbe-körbe frissítene.
  function szovegBeallitas(elem, szoveg) {
    if (elem.textContent !== szoveg) elem.textContent = szoveg;
  }

  function gombFrissites() {
    // A vásárlói kártya is a rács gyereke, de NEM termék — ki kell venni a
    // számlálóból, különben „21 / 97" jelenne meg 20 borítónál (lemérve).
    const racs2 = racsElem();
    const latszik = racs2 ? racs2.querySelectorAll('.product-grid__item').length : 0;

    if (osszesTermek > 0) {
      szovegBeallitas(szamlalo, latszik + ' / ' + osszesTermek);
    }

    if (minden()) {
      // A számláló marad, a gomb megy: legyen látszó vége a listának.
      gomb.remove();
      return;
    }

    gomb.disabled = toltesFolyamatban;
    if (toltesFolyamatban) {
      szovegBeallitas(gomb, 'Töltés…');
    } else if (osszesTermek > latszik) {
      szovegBeallitas(gomb, 'Továbbiak betöltése (' + (osszesTermek - latszik) + ')');
    } else {
      szovegBeallitas(gomb, 'Továbbiak betöltése');
    }
  }

  gomb.addEventListener('click', async function () {
    if (toltesFolyamatban || minden()) return;
    toltesFolyamatban = true;
    gombFrissites();

    try {
      await toltsBe(latszoOldal() + 1);
    } catch (hiba) {
      // Ha nem sikerül, visszaadjuk a számozott lapozót: legyen mivel
      // továbbmenni. Némán elnyelni rosszabb lenne, mint egy régi felület.
      console.warn('[brinuti] utántöltés hiba:', hiba);
      lapozokMegjelenitese();
      gombSor.remove();
      return;
    } finally {
      toltesFolyamatban = false;
    }

    gombFrissites();
  });

  function lapozok() {
    return Array.from(lista.querySelectorAll('.pagination, .brinuti-lapozo-fent'));
  }

  function lapozokElrejtese() {
    lapozok().forEach(function (l) { l.setAttribute('hidden', ''); });
  }

  function lapozokMegjelenitese() {
    lapozok().forEach(function (l) { l.removeAttribute('hidden'); });
  }

  if (utolsoOldal > 1) {
    lapozokElrejtese();
    racs.parentNode.insertBefore(gombSor, racs.nextSibling);
    gombFrissites();

    // A téma görgetésre is tölt: a gombot és a számlálót minden rács-
    // változás után frissítjük, hogy a kettő ugyanazt mutassa.
    let frissitesKert = false;
    new MutationObserver(function () {
      if (frissitesKert) return;
      frissitesKert = true;
      requestAnimationFrame(function () {
        frissitesKert = false;
        if (!toltesFolyamatban) gombFrissites();
      });
    }).observe(lista, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ */
  /* Állapot mentése és visszaállítása                                   */
  /* ------------------------------------------------------------------ */

  function allapotMentes() {
    try {
      sessionStorage.setItem(kulcs, JSON.stringify({
        oldalak: latszoOldal(),
        y: Math.round(window.scrollY),
        ido: Date.now()
      }));
    } catch (e) {
      // Privát ablakban a sessionStorage dobhat. Ilyenkor csak nincs
      // állapotmegőrzés — a lista működik tovább.
    }
  }

  // Termékkártyára kattintáskor mentünk: ez az az út, ahonnan a látogató
  // vissza szokott jönni. A pagehide azért kell mellé, mert billentyűzettel
  // vagy középső gombbal is el lehet navigálni.
  racs.addEventListener('click', function (e) {
    if (e.target.closest('a')) allapotMentes();
  });
  window.addEventListener('pagehide', allapotMentes);

  /* 7. kör, 83. pont: a görgetést CSAK VISSZALÉPÉSKOR állítjuk vissza.

     Eddig a mentett pozíció a címhez tartozott, ezért ha a látogató máshonnan
     érkezett ugyanarra a listára (pl. a főoldali kategóriakörről vagy egy
     szűrőcsempéről), az oldal betöltés után magától „lejjebb ugrott” — pont
     oda, ahol legutóbb abbahagyta. Új belépéskor a lista teteje kell. */
  function visszalepes(esemeny) {
    if (esemeny && esemeny.persisted) return true;
    try {
      const bejegyzes = performance.getEntriesByType('navigation')[0];
      if (bejegyzes && bejegyzes.type === 'back_forward') return true;
    } catch (e) { /* régebbi böngésző: marad a lenti két próba */ }
    // A régi (elavult, de még működő) felület ugyanezt 2-vel jelzi.
    if (performance.navigation && performance.navigation.type === 2) return true;
    // A saját „vissza a listához” útvonal: termékoldalról érkezünk.
    const honnan = document.referrer || '';
    if (honnan.indexOf('/products/') >= 0) {
      try {
        if (new URL(honnan).origin === window.location.origin) return true;
      } catch (e) { /* hibás cím — nem visszalépés */ }
    }
    return false;
  }

  async function allapotVisszaallitas() {
    let allapot = null;
    try {
      allapot = JSON.parse(sessionStorage.getItem(kulcs) || 'null');
    } catch (e) {
      allapot = null;
    }
    if (!allapot) return;

    if (Date.now() - allapot.ido > ERVENYES_MP) {
      try { sessionStorage.removeItem(kulcs); } catch (e) { /* mindegy */ }
      return;
    }

    // Csak akkor töltünk vissza, ha tényleg volt utántöltés.
    if (allapot.oldalak > latszoOldal()) {
      for (let o = latszoOldal() + 1; o <= allapot.oldalak && o <= utolsoOldal; o += 1) {
        try {
          await toltsBe(o);
        } catch (hiba) {
          break;
        }
      }
      gombFrissites();
    }

    if (allapot.y > 0) {
      // Két lépésben: a képek magassága a beszúrás után áll be.
      window.scrollTo({ top: allapot.y, behavior: 'auto' });
      requestAnimationFrame(function () {
        window.scrollTo({ top: allapot.y, behavior: 'auto' });
      });
    }
  }

  // A böngésző saját visszaállítása félrevinne: az eredeti, rövidebb lista
  // magasságához igazítana. Mi magunk állítjuk vissza a pozíciót.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  let visszaallitasFutott = false;

  function visszaallitasIndul(esemeny) {
    // Ha a böngésző a gyorsítótárból adja vissza az oldalt (bfcache), ugyanez
    // a dokumentum éled újra: a kapcsolót le kell venni, különben soha többé
    // nem futna. Duplázástól nem kell tartani, mert ilyenkor a `betoltottOldal`
    // is megmarad, és a visszaállítás csak akkor tölt, ha kevesebb van, mint
    // amennyit elmentettünk.
    //
    // Miért nem elég a bfcache saját visszaállítása? Mérve: a termékoldalról
    // visszalépve nem az elhagyott listát kaptuk vissza, hanem egy korábbi
    // előzmény-bejegyzést (?page=1, 20 kártya) — mert a téma lapozója közben
    // külön bejegyzést írt az előzményekbe.
    if (esemeny && esemeny.persisted) visszaallitasFutott = false;
    if (visszaallitasFutott) return;
    visszaallitasFutott = true;
    if (!visszalepes(esemeny)) return;
    allapotVisszaallitas();
  }

  // Kétféle jelre is nekifutunk. A pageshow a megbízható „vissza"-jelzés, de
  // mérve előfordult, hogy a lista mégis üres maradt utána — ezért a betöltés
  // végén is megpróbáljuk. A kapcsoló miatt nem futhat le kétszer.
  window.addEventListener('pageshow', visszaallitasIndul);
  if (document.readyState === 'complete') {
    visszaallitasIndul(null);
  } else {
    window.addEventListener('load', function () { visszaallitasIndul(null); });
  }
})();
